
import BunnyPlayer from "@/components/BunnyPlayer";

interface LessonContentProps {
  lessonId: string;
  title: string;
  description: string;
  videoId: string;
  posterImage: string;
  onVideoEnd: () => void;
  onVideoLoad?: () => void;
  onVideoError?: () => void;
}

const LessonContent = ({ 
  lessonId, 
  title, 
  description, 
  videoId, 
  posterImage,
  onVideoEnd,
  onVideoLoad,
  onVideoError
}: LessonContentProps) => {
  console.log("LessonContent: Rendering with videoId:", videoId);
  
  return (
    <div>
      {videoId ? (
        <div className="mb-8">
          <h2 className="text-xl font-medium mb-3">{title}</h2>
          <BunnyPlayer
            videoId={videoId}
            lessonId={lessonId}
            title={title}
            poster={posterImage}
            onVideoEnd={onVideoEnd}
            onVideoLoad={onVideoLoad}
            onVideoError={onVideoError}
          />
        </div>
      ) : (
        <div className="mb-8 p-4 border rounded bg-gray-50">
          <h2 className="text-xl font-medium mb-3">{title}</h2>
          <p className="text-gray-600">Selles tunnis video puudub.</p>
        </div>
      )}
      
      <div className="mb-8">
        <h2 className="text-xl font-medium mb-3">Tunni sisu</h2>
        <p className="text-gray-700">{description}</p>
      </div>
    </div>
  );
};

export default LessonContent;
